import RootStateCommit from '@/store/mixins/rootstate-commit';
import MultipleDaysModemLog from '@/resources/modem-log';
import jsona from '@/lib/jsona';

const MODULE_NAME = 'visnetHubModemLog';
const DEFAULT_STATE = {
  modemLog: [],
  error: false
};
const generateModemSeries = signalStrengthArray => [
  {
    type: 'line',
    boostThreshold: 1,
    turboThreshold: 0,
    animation: false,
    name: 'Signal Strength',
    data: signalStrengthArray,
    visible: true,
    showInLegend: true,
    suffix: 'dB',
    marker: { enabled: true, radius: 3 },
    states: { hover: { lineWidthPlus: 0 } }
  }
];
export default {
  namespaced: true,
  state: { ...DEFAULT_STATE },
  /* eslint no-param-reassign: ["error", { "props": false }] */
  mutations: {
    resetStore(state) {
      Object.assign(state, DEFAULT_STATE);
    },
    setErrors(state, error) {
      state.error = error;
    },
    setModemLog(state, newModemLog) {
      state.modemLog = jsona.deserialize(newModemLog);
    }
  },
  actions: {
    fetchModemLogData({ commit }, modemParams) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);
      commit('setErrors', []);

      const { externalVisnetHubId, projectCode, substationCode, startDate, endDate } = modemParams;

      return MultipleDaysModemLog({ externalVisnetHubId })
        .get({
          project_code: projectCode,
          substation_code: substationCode,
          start_date: startDate,
          end_date: endDate
        })
        .then(response => {
          commit('setModemLog', response.data);

          RootStateCommit(commit, 'stopLoading', MODULE_NAME);

          return response.ok;
        })
        .catch(error => {
          commit('setErrors', error);

          RootStateCommit(commit, 'stopLoading', MODULE_NAME);
          RootStateCommit(commit, 'setResponseError', MODULE_NAME);

          return error.ok;
        });
    }
  },
  getters: {
    modemLog: state => state.modemLog,
    modemLogData: state => state.modemLog && generateModemSeries(state.modemLog.signalStrength)
  }
};
